/** Member administration: role, status and ownership changes with explicit confirmation. */
export const teamAdminEn={
 "team.admin.title":"Access",
 "team.admin.owner":"Owner",
 "team.admin.blocked.self":"You can't change your own role or status here.",
 "team.admin.blocked.owner":"Only the workspace owner can change the owner's access.",
 "team.admin.blocked.privileges":"This member has permissions you don't have, so you can't change their access.",
 "team.admin.changeRole":"Change role",
 "team.admin.chooseRole":"Choose the new role",
 "team.admin.roleConfirm":"Change role from {from} to {to}? Their access changes right away.",
 "team.admin.confirmRole":"Confirm role change",
 "team.admin.suspend":"Suspend",
 "team.admin.suspendConfirm":"Suspend this member? They lose access right away. Their role and grants are kept so you can reactivate them.",
 "team.admin.confirmSuspend":"Confirm suspension",
 "team.admin.reactivate":"Reactivate",
 "team.admin.reactivateConfirm":"Reactivate this member? They get their earlier role and grants back.",
 "team.admin.confirmReactivate":"Confirm reactivation",
 "team.admin.remove":"Remove from workspace",
 "team.admin.removeConfirm":"Remove this member? They lose access right away. Their history stays, and you can restore access later.",
 "team.admin.confirmRemove":"Confirm removal",
 "team.admin.restore":"Restore access",
 "team.admin.restoreConfirm":"Restore this member's access with their earlier role and grants?",
 "team.admin.confirmRestore":"Confirm restore",
 "team.admin.transfer":"Make owner",
 "team.admin.transferConfirm":"Make this member the workspace owner? Only the owner can change the owner's access or transfer ownership. You keep your role but are no longer protected as owner.",
 "team.admin.confirmTransfer":"Confirm ownership transfer",
 "team.admin.changed":"Saved.",
 "team.admin.unchanged":"This change was already made.",
 "team.admin.stale":"This member changed since you opened it. Review the current details and try again.",
 "team.admin.denied":"You can no longer make this change.",
 "team.admin.ineligible":"This member can't become owner. They need an active whole-workspace role that can manage members.",
 "team.admin.unknown":"Couldn't confirm the result. Check the member's current details before trying again.",
 "team.admin.failed":"Couldn't load this member's access details.",
 "team.admin.cancel":"Cancel",
 "team.admin.resetTwoFactor":"Reset two-factor",
 "team.admin.resetTwoFactorConfirm":"Reset this member's two-factor sign-in? Their authenticator apps are removed and they are signed out everywhere. At their next sign-in they must add a new authenticator. Their password doesn't change.",
 "team.admin.confirmResetTwoFactor":"Confirm two-factor reset",
 "team.admin.resetTwoFactorOther":"This person also belongs to another workspace, so their two-factor sign-in can't be reset from here.",
};
export const teamAdminRu={
 "team.admin.title":"Доступ",
 "team.admin.owner":"Владелец",
 "team.admin.blocked.self":"Здесь нельзя изменить собственную роль или статус.",
 "team.admin.blocked.owner":"Доступ владельца может изменить только сам владелец.",
 "team.admin.blocked.privileges":"У этого участника есть разрешения, которых нет у вас, поэтому вы не можете изменить его доступ.",
 "team.admin.changeRole":"Изменить роль",
 "team.admin.chooseRole":"Выберите новую роль",
 "team.admin.roleConfirm":"Изменить роль с {from} на {to}? Доступ изменится сразу.",
 "team.admin.confirmRole":"Подтвердить смену роли",
 "team.admin.suspend":"Приостановить",
 "team.admin.suspendConfirm":"Приостановить участника? Доступ прекратится сразу. Роль и права сохранятся, чтобы его можно было восстановить.",
 "team.admin.confirmSuspend":"Подтвердить приостановку",
 "team.admin.reactivate":"Возобновить",
 "team.admin.reactivateConfirm":"Возобновить участника? Он получит прежнюю роль и права.",
 "team.admin.confirmReactivate":"Подтвердить возобновление",
 "team.admin.remove":"Удалить из рабочего пространства",
 "team.admin.removeConfirm":"Удалить участника? Доступ прекратится сразу. История сохранится, доступ можно будет восстановить позже.",
 "team.admin.confirmRemove":"Подтвердить удаление",
 "team.admin.restore":"Восстановить доступ",
 "team.admin.restoreConfirm":"Восстановить доступ участника с прежней ролью и правами?",
 "team.admin.confirmRestore":"Подтвердить восстановление",
 "team.admin.transfer":"Сделать владельцем",
 "team.admin.transferConfirm":"Сделать участника владельцем рабочего пространства? Только владелец может менять доступ владельца и передавать владение. Ваша роль сохранится, но защита владельца перейдёт к нему.",
 "team.admin.confirmTransfer":"Подтвердить передачу владения",
 "team.admin.changed":"Сохранено.",
 "team.admin.unchanged":"Это изменение уже было сделано.",
 "team.admin.stale":"Данные участника изменились после открытия. Проверьте текущие данные и повторите.",
 "team.admin.denied":"Вы больше не можете внести это изменение.",
 "team.admin.ineligible":"Этот участник не может стать владельцем. Нужна активная роль на всё пространство с правом управлять участниками.",
 "team.admin.unknown":"Не удалось подтвердить результат. Проверьте текущие данные участника перед повтором.",
 "team.admin.failed":"Не удалось загрузить данные о доступе участника.",
 "team.admin.cancel":"Отмена",
 "team.admin.resetTwoFactor":"Сбросить двухфакторный вход",
 "team.admin.resetTwoFactorConfirm":"Сбросить двухфакторный вход участника? Его приложения-аутентификаторы будут удалены, а он выйдет на всех устройствах. При следующем входе нужно будет добавить новый аутентификатор. Пароль не меняется.",
 "team.admin.confirmResetTwoFactor":"Подтвердить сброс",
 "team.admin.resetTwoFactorOther":"Этот человек состоит и в другом рабочем пространстве, поэтому сбросить его двухфакторный вход отсюда нельзя.",
};
export const teamAdminKo={
 "team.admin.title":"접근 권한",
 "team.admin.owner":"소유자",
 "team.admin.blocked.self":"여기서는 자신의 역할이나 상태를 변경할 수 없습니다.",
 "team.admin.blocked.owner":"소유자의 접근 권한은 소유자만 변경할 수 있습니다.",
 "team.admin.blocked.privileges":"이 구성원에게 내가 갖지 않은 권한이 있어 접근 권한을 변경할 수 없습니다.",
 "team.admin.changeRole":"역할 변경",
 "team.admin.chooseRole":"새 역할 선택",
 "team.admin.roleConfirm":"역할을 {from}에서 {to}(으)로 변경할까요? 접근 권한이 즉시 바뀝니다.",
 "team.admin.confirmRole":"역할 변경 확인",
 "team.admin.suspend":"일시 중지",
 "team.admin.suspendConfirm":"이 구성원을 일시 중지할까요? 접근 권한이 즉시 중단됩니다. 다시 활성화할 수 있도록 역할과 권한은 유지됩니다.",
 "team.admin.confirmSuspend":"일시 중지 확인",
 "team.admin.reactivate":"다시 활성화",
 "team.admin.reactivateConfirm":"이 구성원을 다시 활성화할까요? 이전 역할과 권한이 복원됩니다.",
 "team.admin.confirmReactivate":"다시 활성화 확인",
 "team.admin.remove":"작업 공간에서 제거",
 "team.admin.removeConfirm":"이 구성원을 제거할까요? 접근 권한이 즉시 중단됩니다. 기록은 남으며 나중에 접근 권한을 복원할 수 있습니다.",
 "team.admin.confirmRemove":"제거 확인",
 "team.admin.restore":"접근 권한 복원",
 "team.admin.restoreConfirm":"이전 역할과 권한으로 이 구성원의 접근 권한을 복원할까요?",
 "team.admin.confirmRestore":"복원 확인",
 "team.admin.transfer":"소유자로 지정",
 "team.admin.transferConfirm":"이 구성원을 작업 공간 소유자로 지정할까요? 소유자만 소유자의 접근 권한을 변경하거나 소유권을 이전할 수 있습니다. 내 역할은 유지되지만 소유자 보호는 해제됩니다.",
 "team.admin.confirmTransfer":"소유권 이전 확인",
 "team.admin.changed":"저장되었습니다.",
 "team.admin.unchanged":"이미 적용된 변경입니다.",
 "team.admin.stale":"열어 본 후 구성원 정보가 변경되었습니다. 현재 정보를 확인하고 다시 시도하세요.",
 "team.admin.denied":"더 이상 이 변경을 할 수 없습니다.",
 "team.admin.ineligible":"이 구성원은 소유자가 될 수 없습니다. 구성원을 관리할 수 있는 활성 전체 작업 공간 역할이 필요합니다.",
 "team.admin.unknown":"결과를 확인하지 못했습니다. 다시 시도하기 전에 구성원의 현재 정보를 확인하세요.",
 "team.admin.failed":"이 구성원의 접근 정보를 불러오지 못했습니다.",
 "team.admin.cancel":"취소",
 "team.admin.resetTwoFactor":"2단계 로그인 재설정",
 "team.admin.resetTwoFactorConfirm":"이 구성원의 2단계 로그인을 재설정할까요? 인증 앱이 삭제되고 모든 기기에서 로그아웃됩니다. 다음 로그인 때 새 인증 앱을 추가해야 합니다. 비밀번호는 바뀌지 않습니다.",
 "team.admin.confirmResetTwoFactor":"재설정 확인",
 "team.admin.resetTwoFactorOther":"이 사용자는 다른 작업 공간에도 속해 있어 여기서 2단계 로그인을 재설정할 수 없습니다.",
};
